import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import {ReactComponent as CrossIcon} from "../../../assets/images/icons/cross.svg";

import './../notifications.css';

export const Failure = () => {

    return (
        <motion.div className="container-fluid notifications"
            initial={{opacity: 0}}
            animate={{opacity: 1, trasition: { duration: 0.7}}}
            exit={{opacity: 0, trasition: { duration: 0.1}}}
        >
            <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="mt-5">
                    <CrossIcon/>
                </div>
                <div className="mt-3 px-3 text-center">
                    <p className="h4">Сталася непередбачена помилка!</p>
                    <p className="h5">Спробуйте ще раз або повторіть спробу пізніше</p>
                </div>
                <div className="mt-5">
                    <Link
                        to={'/'}
                        className="btn"
                    >
                        На головну
                    </Link>
                </div>
            </div>
        </motion.div>
    )
}